import { createContext, useContext } from "react";

const PermissionsContext = createContext({
  authorities: []
});

export const PermissionsProvider = ({ authorities, children }) => {

  return (
    <PermissionsContext.Provider value={{ authorities }}>
      {children}
    </PermissionsContext.Provider>
  );
  
};

export const usePermissionsContext = () => useContext(PermissionsContext);